export { };

declare global {
  export interface Date {
    asUtc(): Date;
  }

  export interface Window {
    utcDate(date: Date): Date;
  }

  function utcDate(date: Date): Date;
}

Window.prototype.utcDate = function utcDate(date: Date): Date | null | undefined {
  return date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds())) : date;
};

Date.prototype.asUtc = function (this: Date) {
  return utcDate(this);
};
